import { render, staticRenderFns } from "./ludimos-goes-into-bat-with-northerns-on-cricket-development.vue?vue&type=template&id=ec24c526&scoped=true&"
var script = {}
import style0 from "./ludimos-goes-into-bat-with-northerns-on-cricket-development.vue?vue&type=style&index=0&id=ec24c526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24c526",
  null
  
)

export default component.exports